/**
 * Generic products are unique per household on `slug` (DATABASE §5.1), and the
 * slug is what stops the fragmentation AI.md §4 warns about — "Oat Milk",
 * "oat milk" and "Oat  Milk" must not become three generics splitting the
 * household's purchase history three ways.
 *
 * Dutch diacritics are folded rather than stripped, so é/ë/ï collapse onto
 * their base letters instead of vanishing and joining two words together.
 */
export function slugify(name) {
    return name
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') // strip combining accents left by NFD
        .toLowerCase()
        .replace(/['’]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 200);
}
//# sourceMappingURL=slug.js.map